import React, { useEffect, FunctionComponent } from 'react';

import { track as trackLogRocket, TrackedEvent } from '@helpers/logRocket';

export const NoResources: FunctionComponent<{}> = () => {
  useEffect(() => {
    trackLogRocket(TrackedEvent.SmartsheetPublishNoResources);
  }, []);

  return (
    <div className="no-resources">
      <div className="submit-success__header">
        <span className="bff-private icon" />
        <h4 className="no-resources__header--title">{bfTranslate('Whoops!')}</h4>
      </div>
      <p className="no-resources__instructions">
        {bfTranslate('It looks like you don’t have permission to publish to any Brandfolder resources.')}
      </p>
      <p className="no-resources__instructions">
        {bfTranslate('Reach out to a Brandfolder admin to request permission.')}
      </p>
    </div>
  );
};
